import styled from '@emotion/styled'

import { colors, NativeLink, spacing, typography } from 'main/ui'

export const Container = styled.div`
  align-items: flex-start;
  border-bottom: 1px solid ${colors.border.default};
  border-top: 1px solid ${colors.border.default};
  display: flex;
  flex-direction: column;
  padding: ${spacing.majorScale(2)}px;
`

export const TopRowContainer = styled.div`
  align-self: stretch;
  display: flex;
  justify-content: space-between;
  margin-bottom: ${spacing.majorScale(1)}px;
`

export const MoreInformationNativeLink = styled(NativeLink)`
  font-size: ${typography.fontSize.small};
  line-height: 20px;
`
